export default __webpack_public_path__ + "static/media/home-icon.e3f7bbab.svg";